(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SECTION_SELECTOR = '#MainContent > .shopify-section:not(:first-child)';
  var MEDIA_SELECTOR = '#MainContent > .shopify-section:not(:first-child) img';

  var observer;

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-revealed');
        observer.unobserve(entry.target);
      }
    }
  }

  function mark(selector, className) {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.classList.contains('scroll-reveal') || el.classList.contains('scroll-reveal-media')) continue;
      el.classList.add(className);
      observer.observe(el);
    }
  }

  function scan() {
    mark(SECTION_SELECTOR, 'scroll-reveal');
    mark(MEDIA_SELECTOR, 'scroll-reveal-media');
  }

  function setup() {
    observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    });
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Re-scan when the theme editor injects or re-renders sections.
  document.addEventListener('shopify:section:load', function () {
    if (!observer) {
      setup();
    } else {
      scan();
    }
  });
})();
